import { useEffect, useState } from "react";
import './Sidebar.css';
import { Link } from "react-router-dom";
import { sideBarByRoleId } from "../services/sideBar";
//import { useAppData } from "../context/AppDataProvider";
const Sidebar = () => {
    //const{menuData,loading}=useAppData();
    const [menuData, setMenuData] = useState([]);
    const [openMenu, setOpenMenu] = useState(0);
    const toggleMenu = (index) => {
        setOpenMenu(openMenu === index ? null : index);
    };
    const [loading, setLoading] = useState(false);
    //Get roleId from localStorage
    const roleId = localStorage.getItem("roleid");

    // fetch Menus
    useEffect(() => {
        const fetchMenus = async () => {
            if (!roleId) return;
            setLoading(true);
            try {
                const response = await sideBarByRoleId(Number(roleId));
                console.log("sidebar", response);
                if (response?.statusCode === 200 && response?.success) {
                    setMenuData(response.data);

                    //    Start Permission
                    const allowedRoutes = response.data.flatMap(
                        menu => menu.submenu.map(item => item.path)
                    );

                    localStorage.setItem(
                        "permissions",
                        JSON.stringify(allowedRoutes)
                    );
                    //    End Permission
                }
            } catch (error) {
                console.log(error);
            } finally {
                setLoading(false);
            }
        };

        fetchMenus();
    }, [roleId]);
    return (
        <div
            className="position-fixed top-0 start-0"
            style={{
                width: "230px",
                background: "#cfdcf2",
                top: "52px",
                bottom: "0",
                overflowY: "auto",
                marginTop: "52px",
            }}
        >
            <div className="p-3">
                {loading && <p>Loading...</p>}
                {menuData.map((menu, index) => (
                    <div key={index}>

                        {/* HEADER */}
                        <div
                            className="d-flex justify-content-between align-items-center p-2 fw-semibold sidebar-item"
                            onClick={() => toggleMenu(index)}
                            style={{ cursor: "pointer" }}
                        >
                            <div>
                                <i className={`fa ${menu.icon} me-2`}></i>
                                {menu.title}
                            </div>

                            <i
                                className={`fa ${openMenu === index
                                    ? "fa-angle-down"
                                    : "fa-angle-left"
                                    }`}
                            ></i>
                        </div>

                        {/* SUBMENU */}
                        {openMenu === index && (
                            <div className="bg-light ps-4 py-2 sidebar-submenu">

                                {menu.submenu.map((sub, subIndex) => (
                                    <Link
                                        key={subIndex}
                                        to={sub.path}
                                        className="d-block py-2 text-decoration-none"
                                    >
                                        {sub.name}
                                    </Link>
                                ))}

                            </div>
                        )}

                    </div>
                ))}

            </div>
        </div>
    );
};
export default Sidebar;